(ns net.kestec.mhda-pilgrimage.admin.applications.application-detail
  (:require
    ["@mui/material/Paper" :default Paper]

    [net.kestec.mhda-pilgrimage.admin.applications.application-detail-data-view :as data-view]
    [net.kestec.mhda-pilgrimage.admin.applications.application-detail-actions :as documents-view]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]

    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))



(defn main []
  (let [application-id @(rf/subscribe [::db/get ::route/route :path-params :application-id])
        application (first (filter #(= application-id (:id %)) @(rf/subscribe [::db/get ::admin-applications-events/admin-applications])))]
    (if application
      [base-page
       [:> Paper {:sx {:padding "7px"}}
        [data-view/validator-details]
        [data-view/data-view]
        [documents-view/action-part]

        ]]
      [base-page
       [:> Paper {:sx {:padding "7px"}}
        [:h1 "kein Antrag"]]]
      )))